
import Cell from 'vux/src/components/cell/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

export default{
components:{
Cell,
PopupPicker,
},
data(){
return {
jsDate:"",     //实际时间
jspickerDate:[], //pick时间
showPopupPicker:false, //显示弹出的日历
loginFlag:true,
mrvalue:this.label?"请选择用车时间":"请先设置航班号",
upMsg:"请选择上车地点",
downMsg:"请选择下车地点"
}
},
props:["upvalue","downvalue","list","label","mrDate"],
watch:{
jspickerDate:function(newValue,oldValue){

},
upvalue:function(newValue, oldValue){
if(this.$until.getUrlParam("noTime")|| localStorage.getItem("noTime")){return;}
this.jsDate = "";
var jbStorage = JSON.parse(window.localStorage.getItem("jbStorage"));
if(jbStorage){
jbStorage.jsPassager = "";
jbStorage.jsPassageValue = "";
window.localStorage.setItem("jbStorage",JSON.stringify(jbStorage));
}


this.$emit('input',this.jsDate);
this.$emit('callPrice');
},
downvalue: function(newValue, oldValue){
if(this.$until.getUrlParam("noTime") || localStorage.getItem("noTime")){return;}
this.jsDate = "";
var jbStorage = JSON.parse(window.localStorage.getItem("jbStorage"));
if(jbStorage){
jbStorage.jsPassager = "";
jbStorage.jsPassageValue = "";
window.localStorage.setItem("jbStorage",JSON.stringify(jbStorage));
}
this.$emit('input',this.jsDate);
this.$emit('callPrice');
}
},

methods:{
yz(val){
return this.$until.yzFontColor(val);
},

yzDatePerson(){
if(this.mrDate){return};
this.upMsg = !this.label ? "请选择接机起始点" : this.upMsg;
this.downMsg = !this.label ? "请选择接机终点" : this.downMsg;
if (typeof  this.upvalue != "object"){
this.$vux.toast.show({
text:this.upMsg,
type:"text"
})
return;
} else if (!this.downvalue){
this.$vux.toast.show({
text:this.downMsg,
type:"text"
})
return;
}
this.showPopupPicker = true;
},
me(){
this.showPopupPicker = false
this.jsDate = this.$refs.jspickerDate && this.$refs.jspickerDate.getNameValues()

this.$emit('input',this.jsDate);
var jbStorage = window.localStorage.getItem("jbStorage")
if (jbStorage){
jbStorage = JSON.parse(jbStorage);
jbStorage.jsPassager = this.jspickerDate;
jbStorage.jsPassageValue = this.jsDate
window.localStorage.setItem("jbStorage",JSON.stringify(jbStorage));
} else {
window.localStorage.setItem("jbStorage",JSON.stringify({
"jsPassager":this.jspickerDate,
"jsPassageValue":this.jsDate
}));
}
},
},
activated(){
var jbStorage = window.localStorage.getItem("jbStorage")
if (jbStorage){
jbStorage = JSON.parse(jbStorage);
if(!jbStorage.jsPassager) return;
this.jspickerDate = jbStorage.jsPassager ? jbStorage.jsPassager : [];
this.jsDate = jbStorage.jsPassageValue ? jbStorage.jsPassageValue : "";
} else {
this.jspickerDate = [];
this.jsDate = "";
}
},
mounted(){
this.list3 = this.list;
var jbStorage = window.localStorage.getItem("jbStorage");

if (jbStorage){
jbStorage = JSON.parse(jbStorage);
if(!jbStorage.jsPassager) return;
this.jspickerDate = jbStorage.jsPassager ? jbStorage.jsPassager : [];
this.jsDate = jbStorage.jsPassageValue ? jbStorage.jsPassageValue : "";
} else {
this.jspickerDate = [];
this.jsDate = "";
}

this.$emit('input',this.jsDate);
}
}



// WEBPACK FOOTER //
// ./src/components/common/datePick.vue